import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Location } from '@angular/common';
import { LoadingService } from "./services/loading/loading.service";
import { CommonService } from "./services/common.service";
import { AuthService } from "./services/auth/auth.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {


  constructor(
    private location: Location,
    public _loading: LoadingService,
    private cdref: ChangeDetectorRef,
    private _common: CommonService,
    private _auth: AuthService,
  ) {
    this.location.onUrlChange((url: string) => {
      if (_auth.isAuthenticatedUser()) {
        this.getAlertsCount();
      };
    });
  }


  title = 'dpBack';


  isLoggedIn : boolean
  alertCount = 0



  
  ngOnInit(): void { 

     
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  isLoginPage() {
    return this.location.path() === '';
  }

  isForgotPage(): boolean {
    return this.location.path().includes('/forgot-password');
  }

  isResetPage(): boolean {
    return this.location.path().includes('/reset-password');
  }
  
  getAlertsCount() {
    this._common.get(`office/getAlertsCount`).subscribe((resp: any) => {
      if (resp.data) {
        this.alertCount = resp.data.count;
      }
    });
  }

}
